<template>
  <table class="table table-hover">
    <thead>
      <tr>
        <th
          v-for="(col, idx) in columns"
          v-bind:key="idx"
          v-on:mouseup="sortColumn(col.idx)"
          v-bind:class="{ 'text-center': col.center }"
          v-bind:aria-sort="ariaSort(col.idx)"
          class="c-hand"
        >
          {{ col.name }}<sub v-if="col.sub">{{ col.sub }}</sub>
          <span v-if="sortArrow(col.idx)">&nbsp;{{ sortArrow(col.idx) }}</span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(t, idx) in gens"
        v-bind:key="idx"
        v-on:mouseup="navigateToGen(t.idx)"
        class="c-hand"
      >
        <td>{{ t.gen[GEN_BUS] }}</td>
        <td class="text-right">
          <span v-if="t.gen[PG]">
            {{ activePower(t.gen) }}<span class="hide-sm"> MW</span>
          </span>
        </td>
        <td class="text-right">
          <span v-if="t.gen[QG]">
            {{ reactivePower(t.gen) }}<span class="hide-sm"> MVAr</span>
          </span>
        </td>
        <td class="text-right">
          <span v-if="t.gen[MU_PMAX]">
            {{ muPMax(t.gen) }}<span class="hide-sm"> $/MW</span>
          </span>
        </td>
        <td class="text-right">
          <span v-if="t.gen[MU_PMIN]">
            {{ muPMin(t.gen) }}<span class="hide-sm"> $/MW</span>
          </span>
        </td>
        <td class="text-right">
          <span v-if="t.gen[MU_QMAX]">
            {{ muQMax(t.gen) }}<span class="hide-sm"> $/MVAr</span>
          </span>
        </td>
        <td class="text-right">
          <span v-if="t.gen[MU_QMIN]">
            {{ muQMin(t.gen) }}<span class="hide-sm"> $/MVAr</span>
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import numeral from "numeral-es6";
import PFStore from "../../stores/PFStore";

import {
  GEN_BUS,
  PG,
  QG,
  MU_PMAX,
  MU_PMIN,
  MU_QMAX,
  MU_QMIN
} from "../../stores/idx";

export default {
  name: "GenOPFTable",
  data() {
    return {
      columns: [
        { idx: GEN_BUS, name: "Bus" },
        { idx: PG, name: "P", sub: "g", center: true },
        { idx: QG, name: "Q", sub: "g", center: true },
        { idx: MU_PMAX, name: "μ", sub: "Pmax", center: true },
        { idx: MU_PMIN, name: "μ", sub: "Pmin", center: true },
        { idx: MU_QMAX, name: "μ", sub: "Qmax", center: true },
        { idx: MU_QMIN, name: "μ", sub: "Qmin", center: true }
      ],
      sorted: -1,
      ascending: false,
      GEN_BUS: GEN_BUS,
      PG: PG,
      QG: QG,
      MU_PMAX: MU_PMAX,
      MU_PMIN: MU_PMIN,
      MU_QMAX: MU_QMAX,
      MU_QMIN: MU_QMIN
    };
  },
  computed: {
    gens() {
      let idx = this.sorted;
      let up = this.ascending;
      return PFStore.methods
        .getGens()
        .map((gen, idx) => ({ gen, idx }))
        .sort(function(a, b) {
          if (idx >= 0) {
            return up ? b.gen[idx] - a.gen[idx] : a.gen[idx] - b.gen[idx];
          }
          return 0;
        });
    }
  },
  methods: {
    navigateToGen(idx) {
      this.$router.push({ name: "gen", params: { ord: idx + 1 } });
    },
    sortColumn(idx) {
      if (this.sorted === idx) {
        this.ascending = !this.ascending;
      } else {
        this.sorted = idx;
        this.ascending = false;
      }
    },
    ariaSort(idx) {
      if (this.sorted === idx) {
        return this.ascending ? "ascending" : "descending";
      }
      return "none";
    },
    sortArrow(idx) {
      if (this.sorted === idx) {
        return this.ascending ? "▴" : "▾";
      }
    },
    activePower(gen) {
      return numeral(gen[PG]).format("0.[00]");
    },
    reactivePower(gen) {
      return numeral(gen[QG]).format("0.[00]");
    },
    muPMax(gen) {
      return numeral(gen[MU_PMAX]).format("0.[00]");
    },
    muPMin(gen) {
      return numeral(gen[MU_PMIN]).format("0.[00]");
    },
    muQMax(gen) {
      return numeral(gen[MU_QMAX]).format("0.[00]");
    },
    muQMin(gen) {
      return numeral(gen[MU_QMIN]).format("0.[00]");
    }
  }
};
</script>
